import React, { useState, useRef, useEffect } from "react";
import "./NestedDropdown.css";

const NestedDropdown = ({ sections = [], onChange, defaultValues = {}, externalSearchValue}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [openSections, setOpenSections] = useState({});
  const [selected, setSelected] = useState(defaultValues);
  const [searchInputs, setSearchInputs] = useState({});

  useEffect(() => {
    if (externalSearchValue) {
      setSearchInputs(prev => ({ ...prev, ...externalSearchValue }));

      setSelected(prev => {
        const next = { ...prev, ...externalSearchValue };
        Object.keys(externalSearchValue).forEach(key => {
          if (!externalSearchValue[key]) delete next[key];
        });
        return next;
      });
    }
  }, [externalSearchValue]);

  const toggleSection = (key) => {
    setOpenSections(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleItem = (sectionKey, itemValue, multiselect) => {
    const prevValues = selected[sectionKey] || [];
    const nextValues = multiselect
      ? prevValues.includes(itemValue)
        ? prevValues.filter(v => v !== itemValue)
        : [...prevValues, itemValue]
      : [itemValue];

    const next = {
      ...selected,
      [sectionKey]: nextValues,
    };

    setSelected(next);

    setTimeout(() => onChange && onChange(next), 0);
  };

  const handleSearchInput = (sectionKey, value) => {
    setSearchInputs(prev => ({
      ...prev,
      [sectionKey]: value,
    }));
  };

  const handleSearchSubmit = (sectionKey) => {
    setSelected(prev => {
      const next = {
        ...prev,
        [sectionKey]: searchInputs[sectionKey] || "",
      };
      setTimeout(() => onChange && onChange(next), 0);
      return next;
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="filter-dropdown-container" ref={containerRef}>
      <button
        type="button"
        className={`filter-btn ${isOpen ? "active" : ""}`}
        onClick={() => {
          setIsOpen(v => !v);
          if (!isOpen) setOpenSections({});
        }}
      >
        <i className={`fa-solid fa-chevron-${isOpen ? "up" : "down"}`} />
      </button>

      {isOpen && (
        <div className="filter-menu">
          {sections.map(section => (
            <div key={section.value} className="filter-section">
              <div
                className="filter-section-header"
                onClick={() => toggleSection(section.value)}
              >
                <i className={`fa-solid fa-chevron-${openSections[section.value] ? "up" : "down"}`} />
                <span>{section.label}</span>
              </div>

              {openSections[section.value] && (
                <div className="filter-list">
                  {section.type === "search" ? (
                    <div className="search d-flex">
                      <div className="search-wrapper">
                        <div className="icon-wrapper">
                          <i className="fa-solid fa-magnifying-glass"></i>
                        </div>
                        <input
                          className="search-input"
                          type="text"
                          value={searchInputs[section.value] || ""}
                          onChange={(e) => handleSearchInput(section.value, e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSearchSubmit(section.value);
                            }
                          }}
                          placeholder={`Пошук...`}
                        />
                      </div>
                    </div>
                  ) : (
                    section.children?.map(item => (
                      <label key={item.value} className="filter-item">
                        <input
                          type="checkbox"
                          checked={selected[section.value]?.includes(item.value) || false}
                          onChange={() =>
                            toggleItem(
                              section.value,
                              item.value,
                              section.type !== "single"
                            )
                          }
                        />
                        <span className="filter-label">{item.label}</span>
                      </label>
                    ))
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NestedDropdown;
